import moment from "moment";
import { getClientJWTInfo } from "../services/accountService";
import {
  differenceInCalendarDays,
  add as dateAdd,
  format as dateFormat,
} from "date-fns";
import { basePath } from "../config";
import {
  cdkSubscriptionStatuses,
  codOptions,
  deliveryExceptions,
  orderStatuses,
} from "../constants";
import { toast } from "react-toastify";
import { Buffer } from "buffer";

//probaby just use date-fns format
export const formatDate = (date) => {
  const dateObject = new Date(date);
  return dateObject.toLocaleDateString();
};

export const changeFormatDate = (
  date,
  dateFormat = "",
  outputFormat,
  isUTC = false
) => {
  const dateObject = isUTC
    ? moment.utc(date, dateFormat)
    : moment(date, dateFormat);

  return dateObject.format(outputFormat);
};

const timeCodeMeanings = {
  NN: "Noon",
  NT: "Night",
  ND: "Next Day",
  SD: "Same Day",
};

export const getTimeCodeMeaning = (timeCode) => {
  return timeCodeMeanings[timeCode] ?? "-";
};

const zipRegex = new RegExp("^[0-9]{5}(?:-[0-9]{4})?$");
export const isValidZipCode = (zipCode) => {
  return zipRegex.test(zipCode);
};

export const isValidAddress = (city, state, zip) => {
  return city !== "" && state !== "" && zip.length >= 5;
};

export const isValidEmailorEmpty = (email, index) => {
  if (index === 0 && email === "") {
    return false;
  } else {
    return /^\S+@\S+\.\S+$/.test(email) || email === "";
  }
};

export const sleep = (ms) => {
  return new Promise((res) => setTimeout(res, ms));
};

export const isValidEmail = (email, index) => {
  if (index === 0 && email === "") {
    return false;
  } else {
    return /^\S+@\S+\.\S+$/.test(email);
  }
};

export const genericValidationTest = (inputValue, lengthMin = 3) => {
  return inputValue.length >= lengthMin;
};
export const selectValidationTest = (inputValue) => {
  return inputValue !== "";
};

export const CapitalizeFirstLetters = (string) => {
  if (string) {
    const parts = string.split(" ");
    const partsCapitalized = parts.map((part) => {
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    });
    return partsCapitalized.join(" ");
  }
};

export const convertSecondsIntoHoursMinutesSeconds = (
  seconds,
  roundUpSeconds = true
) => {
  return {
    hours: Math.floor(seconds / 3600),
    minutes: roundUpSeconds
      ? Math.ceil((seconds / 60) % 60)
      : Math.floor((seconds / 60) % 60),
    seconds: roundUpSeconds ? 0 : seconds % 60,
  };
};
export const convertMetersToMiles = (meters) => {
  return meters * 0.000621371192;
};

export const cleanWhiteSpace = (
  string,
  options = { trim: true, inBetween: true, keepSingleSpaceInBetween: true }
) => {
  const { trim, inBetween, keepSingleSpaceInBetween } = options;
  if (inBetween === true) {
    return trim
      ? string.replace(/ +(?= )/g, keepSingleSpaceInBetween ? " " : "").trim()
      : string.replace(/ +(?= )/g, keepSingleSpaceInBetween ? " " : "");
  } else {
    return string.trim();
  }
};

export const arrayShuffle = (array) => {
  const shuffledArray = [...array];
  let currentIndex = array.length;
  while (currentIndex != 0) {
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [shuffledArray[currentIndex], shuffledArray[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }
  return shuffledArray;
};

export const randomFloatBetween = (min, max) => {
  return Math.random() * (max - min) + min;
};

export const mapRange = (value, inMin, inMax, outMin, outMax) => {
  return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
};

export const escapeHTML = (string) => {
  var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;",
    "`": "&#x60;",
    "=": "&#x3D;",
  };

  return String(string).replace(/[&<>"'`=\/]/g, function (s) {
    return entityMap[s];
  });
};

export const dateObjectFromDateInputString = (dateString) => {
  //Alternate option for getting a dateObject from a dateString in the format "yyyy-MM-dd"
  //other options:
  //date-fns parse, parseISO
  //new Date(dateString);
  const dateParts = dateString.split("-");
  const year = dateParts[0];
  const month = dateParts[1] - 1;
  const day = dateParts[2];

  return new Date(year, month, day);
};

export const dateZeroTime = (dateObject) => {
  const newDate = new Date(dateObject); //setHours mutates the original dateObject, so we create a copy first.
  return newDate.setHours(0, 0, 0, 0);
};
//pass in currentDate as a slight optimization (so we can store it in state and don't have to recreate it in each call)
export const dateBeforeMidnightOfCreationDate = (
  creationDateObject,
  currentDate
) => {
  return currentDate < dateAdd(dateZeroTime(creationDateObject), { hours: 24 });
};
//assumes dateObject has time zeroed out because as of right now delivery dates do not get a time assigned and are always zeroed out.
export const dateAfterDeliveryDate = (deliveryDateObject, currentDate) => {
  return currentDate >= dateAdd(deliveryDateObject, { days: 1 });
};

//Expects the greater date to be the first argument (for a positive result, otherwise result will be negative)
export const getDifferenceInDaysForDateInputStrings = (
  dateString1,
  dateString2
) => {
  const dateObj1 = dateObjectFromDateInputString(dateString1);
  const dateObj2 = dateObjectFromDateInputString(dateString2);
  return differenceInCalendarDays(dateObj1, dateObj2);
};
//Split date range into array of smaller date ranges with size based on dayAmount
const splitDateRange = (fromDate, toDate, dayAmount) => {
  // console.log("from date", fromDate);
  // const fromDateObject = new Date(fromDate);
  // console.log("from date Object", fromDateObject);
  // console.log(
  //   "from date Object converted",
  //   dateFormat(fromDateObject, "yyyy-MM-dd")
  // );
  let splitWeeksArray = [];
  let dateCrawler = new Date(fromDate.replace("-", "/"));
  // console.log("split weeks start", dateCrawler);
  const endDate = new Date(toDate.replace("-", "/"));
  // console.log("split weeks end", endDate);

  while (dateCrawler < endDate) {
    // console.log("split weeks dateCrawler current", dateCrawler);
    const dateChunkEnd = dateAdd(dateCrawler, { days: dayAmount });
    // console.log("split weeks chunkEndDate", dateChunkEnd);
    splitWeeksArray.push({
      fromDate: dateFormat(dateCrawler, "yyyy-MM-dd"),
      toDate: dateFormat(
        dateChunkEnd <= endDate ? dateChunkEnd : endDate,
        "yyyy-MM-dd"
      ),
    });
    dateCrawler = dateChunkEnd;
  }

  return splitWeeksArray;
};

export const convertArrayToGetParamsArrayString = (array, arrayParamName) => {
  //for arrayParamName pass in what the backend expects as the variable name
  return array
    .map((element, index) => `${arrayParamName}[${index}]=${element}`)
    .join("&");
};

export const svgStringToBase64 = (svgString) => {
  return Buffer.from(svgString).toString("base64");
};
export const svgStringToImgSrc = (svgString) => {
  return "data:image/svg+xml;base64," + svgStringToBase64(svgString);
};

export const base64ToImgSrc = (base64String) =>
  "data:image/jpg;base64," + base64String;

export const deriveDeliveryTypeFromRefNo = (refNo) => {
  const refNoTrimmed = refNo?.trim();
  return refNoTrimmed === "PKUP-RTN"
    ? "Return"
    : refNoTrimmed === "B/O"
    ? "Buy Out"
    : "Regular";
};
export const omitReturnsAndBuyoutsFromNeverScannedReport = () => {
  // console.log(18432);
  // console.log(getClientJWTInfo().ClientId);
  return ![18432].includes(getClientJWTInfo().ClientId);
};

export const deriveCODTypeFromDeliveryInfo = (deliveryInfo) => {
  return deliveryInfo?.cod === "Y"
    ? "COD"
    : deliveryInfo?.cash === "Y"
    ? "Certified Funds"
    : "None";
};

//from https://stackoverflow.com/a/34910965/12156650
function excelAlphaToNum(alpha) {
  var i = 0,
    num = 0,
    len = alpha.length;

  for (; i < len; i++) {
    num = num * 26 + alpha.charCodeAt(i) - 0x40;
  }

  return num - 1;
}
//from https://stackoverflow.com/a/34910965/12156650
function excelNumToAlpha(num) {
  var alpha = "";
  num = num - 1; //without this we get 0=A, 1=B, 2=C. We want 1=A, 2=B, 3=C, etc
  for (; num >= 0; num = parseInt(num / 26, 10) - 1) {
    alpha = String.fromCharCode((num % 26) + 0x41) + alpha;
  }

  return alpha;
}

export const exportDataToExcel = (
  data,
  customHeaders,
  fileName,
  sheetName = "Sheet 1"
) => {
  const rowAmount = data.length;
  const colAmount = Object.keys(data[0]).length;
  const lastColumnLetter = excelNumToAlpha(colAmount);

  const XLSX = require("xlsx-js-style");
  const workBook = XLSX.utils.book_new();
  let workSheet;
  if (customHeaders) {
    //create the worksheet with the data but skip first line
    workSheet = XLSX.utils.json_to_sheet(data, {
      origin: "A2",
      skipHeader: true,
    });
    //add custom headers to first line
    //our function accepts headers as an array but the sheet_add_aoa function accepts an "aoa", array of arrays, so we wrap our array in another one
    // let styledHeaders = customHeaders.map((header) => {
    //   return {
    //     v: header,
    //     t: "s",
    //     s: { fill: { patternType: "solid", fgColor: { theme: 4, tint: 0.4 } } },
    //   };
    // });
    XLSX.utils.sheet_add_aoa(workSheet, [customHeaders]);
    //START STYLE CELLS
    let headerStyle = {
      font: {
        bold: true,
        color: {
          rgb: "ffffff",
        },
      },
      fill: { patternType: "solid", fgColor: { theme: 4 } },
    };
    for (const cell in workSheet) {
      //resources used to help with styling
      //https://www.npmjs.com/package/xlsx-js-style
      //https://stackoverflow.com/a/69738925/12156650
      if (typeof workSheet[cell] != "object") {
        continue;
      }
      let decodedCell = XLSX.utils.decode_cell(cell);
      let evenCellStyle = {
        fill: {
          patternType: "solid",
          fgColor: { theme: 4, tint: 0.8 },
        },
        border: {
          top: {
            style: "thin",
            color: {
              theme: 4,
              tint: 0.6,
            },
          },
          bottom: {
            style: "thin",
            color: {
              theme: 4,
              tint: 0.6,
            },
          },
          right:
            decodedCell.c === colAmount - 1
              ? {
                  style: "thin",
                  color: {
                    theme: 4,
                    tint: 0.6,
                  },
                }
              : null,
        },
      };
      let oddCellStyle = {
        border: {
          bottom:
            decodedCell.r === rowAmount
              ? {
                  style: "thin",
                  color: {
                    theme: 4,
                    tint: 0.6,
                  },
                }
              : null,
          right:
            decodedCell.c === colAmount - 1
              ? {
                  style: "thin",
                  color: {
                    theme: 4,
                    tint: 0.6,
                  },
                }
              : null,
        },
      };

      //headers
      if (decodedCell.r === 0) {
        workSheet[cell].s = headerStyle;
      } else if (decodedCell.r % 2 === 1) {
        //above condition: since it is 0 based index 1, 3, 5 will be the even rows
        workSheet[cell].s = evenCellStyle;
      } else {
        workSheet[cell].s = oddCellStyle;
      }
    }

    // for (let i = 1; i <= rowAmount; i++) {
    //   // console.log(`Cell: A${i}`);
    //   workSheet[`A${i}`].s = {
    //     fill: {
    //       patternType: "solid",
    //       fgColor: { theme: 4, tint: 0.4 },
    //     },
    //   };
    // }
    //END STYLE
  } else {
    workSheet = XLSX.utils.json_to_sheet(data);
  }
  // console.log(data[0]);
  // console.log(Object.keys(data[0]));
  // console.log(excelNumToAlpha(2));
  // console.log(excelNumToAlpha(26));
  workSheet["!autofilter"] = {
    ref: `A1:${lastColumnLetter}${rowAmount}`,
  };
  XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
  // XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
  XLSX.writeFile(workBook, `${fileName}.xlsx`);
};

export const openInNewTab = (
  url,
  prependBasePath = false // this is false by default because existing code manually added the basepath before calling this function
) => {
  window.open(
    prependBasePath ? basePath + url : url,
    "_blank",
    "noreferrer noopener"
  );
};
export const prependBasePath = (url) => {
  return basePath + url;
};

export const stopCountsAsScanned = (scan) => {
  //https://diligentapps.atlassian.net/wiki/spaces/DMSDOCSPACE/pages/16613387/Statuses
  // const validPickupScan =
  //   scan.stopType === 0 &&
  //   !scan.contractStopId &&
  //   (scan.scannedWhen || scan.completedTime);
  // const validInTransitOrOutForDeliveryScan =
  //   (scan.stopType === 5 || (scan.stopType === 0 && scan.contractStopId)) &&
  //   scan.scannedWhen;
  // const validDeliveryScan =
  //   scan.stopType === 1 && (scan.scannedWhen || scan.completedTime);
  // return (
  //   validPickupScan || validInTransitOrOutForDeliveryScan || validDeliveryScan
  // );

  //let's just do this
  //if the stop has a scan(scannedWhen regardless of stopType) or it is a delivery/pickup stop(stopType 1/stopType 0 with null contractStopId) that has a completedTime
  //we consider it
  if (
    scan.scannedWhen ||
    ((scan.stopType === 1 || (scan.stopType === 0 && scan.contractStopId)) &&
      scan.completedTime)
  ) {
    return true;
  }
  return false;
};

//the following function determineIssuesWithBarcode expects
//an array of stops, with at least one delivery stop, as right now we are only accounting for issues at delivery.
//Stops that do not have a scannedWhen should be filtered out unless they are a completed delivery stop
//the stops should be sorted how we normally sort them, with the most recent stop at index 0, and least recent at the last index
//the function returns an array of objects, each object has a single property for now, message, describing the issue found.
export const determineIssuesWithBarcode = (stopsArray) => {
  //=======Determine issues with order=========
  let exceptions = [];
  const mostRecentStop = stopsArray[0];
  const mostRecentStopWasDelivery = mostRecentStop?.stopType === 1;
  if (mostRecentStopWasDelivery) {
    const barcodeWasScannedAtDelivery =
      mostRecentStopWasDelivery &&
      mostRecentStop?.scannedWhen !== null &&
      mostRecentStop?.scannedWhen !== "";
    const barcodeStopsWithScans = stopsArray?.filter((trackingHistoryRow) => {
      return trackingHistoryRow.scannedWhen;
    });
    // const wasScannedOntoWrongOrderAtDelivery =
    //   mostRecentStop.reference1?.trim() !== mainInvoice?.trim();
    // const deliveryScanOnWrongOrderAtAnyPoint = getNotScannedStatusResults[
    //   selectedParcel
    // ]?.some((trackingEntry) => {
    //   return (
    //     trackingEntry.stopType === 1 &&
    //     trackingEntry.reference1?.trim() !== mainInvoice?.trim()
    //   );
    // });
    const barcodeHadAnyScans = barcodeStopsWithScans.length > 0;
    if (!barcodeWasScannedAtDelivery) {
      // console.log("Barcode not scanned on delivery");
      if (barcodeHadAnyScans) {
        exceptions.push(deliveryExceptions.hadScansButNotOnDelivery.message);
      } else {
        exceptions.push(deliveryExceptions.hasNoScans.message);
      }
    }
    // if (deliveryScanOnWrongOrderAtAnyPoint) {
    //   if (wasScannedOntoWrongOrderAtDelivery) {
    //     exceptions.push(deliveryExceptions.deliveryScanOnWrongOrder.message);
    //   } else {
    //     exceptions.push(
    //       deliveryExceptions.deliveryScanPreviouslyOnWrongOrder.message
    //     );
    //   }
    // }
  }
  return exceptions;
};
export const processAndFilterStops = (stopsArray) => {
  let stops = [...stopsArray]; //copy array so we don't mutate the original

  let hasDeliveryStopWithScan = false; //if it has a delivery stop with a scan, we will ignore delivery stops without scans
  let hasMultipleDeliveryStopWithScan = false;
  let hasDeliveryStopCompletedWithoutScan = false;
  for (let i = 0; i < stops.length; i++) {
    let currentScan = stops[i];
    if (currentScan.stopType === 1) {
      //look through delivery stops
      if (
        //if it has a scan time
        currentScan.scannedWhen
      ) {
        if (hasDeliveryStopWithScan) {
          hasMultipleDeliveryStopWithScan = true;
        } else {
          hasDeliveryStopWithScan = true;
        }
      } else {
        //delivery stop without a scan
        hasDeliveryStopCompletedWithoutScan = true;
      }
    }
  }
  const onlyCompletedDeliveryStopWithoutScan =
    hasDeliveryStopCompletedWithoutScan && !hasDeliveryStopWithScan;

  try {
    stops = stops.sort((a, b) => {
      //if the only delivery was never scanned but manually completed, we'll just show that at the top, otherwise just sort everything by scannedWhen
      // if (onlyCompletedDeliveryStopWithoutScan) {
      //   if (b.stopType === 1) {
      //     return 1;
      //   }
      //   if (a.stopType === 1) {
      //     return -1;
      //   }
      // }
      //Per Jesse/Matt we want to move all delivery stops to the top, regardless of any other logic
      if (b.stopType === 1 && a.stopType === 1) {
        //if both are deliveries
        //try to sort be scannedWhen
        if (a.scannedWhen && b.scannedWhen) {
          if (a.scannedWhen === b.scannedWhen) {
            return b.pkid - a.pkid;
          }
          return Date.parse(b.scannedWhen) - Date.parse(a.scannedWhen);
        } else if (a.scannedWhen && b.completedTime) {
          return Date.parse(b.scannedWhen) - Date.parse(a.completedTime);
        } else if (a.completedTime && b.scannedWhen) {
          return Date.parse(b.completedTime) - Date.parse(a.scannedWhen);
        } else {
          if (a.completedTime === b.completedTime) {
            return b.pkid - a.pkid;
          }
          return Date.parse(b.completedTime) - Date.parse(a.completedTime);
        }
      }
      if (b.stopType === 1) {
        return 1;
      }
      if (a.stopType === 1) {
        return -1;
      }

      //if the scanned when is equal sort by pkid.
      if (a.scannedWhen === b.scannedWhen) {
        return b.pkid - a.pkid;
      }
      //if scanned when is null keep them in the beginning. (if both a and b scannedWhens are null it will sort by pkid in the above if statement)
      if (a.scannedWhen === null || a.scannedWhen === "") {
        return 1;
      }
      if (b.scannedWhen === null || b.scannedWhen === "") {
        return -1;
      }
      // console.log(b.scannedWhen - a.scannedWhen);
      //for anything else sort by scannedWhen
      return Date.parse(b.scannedWhen) - Date.parse(a.scannedWhen);
    });
    //Moved the filtering after sorting as we need the sorted stops including completed delivery stops that don't have a scan on them to calculate one of the exceptions.
    const issues = determineIssuesWithBarcode(stops);

    //if we have a delivery stop with a scan, let's ignore the ones with only a completion time, again example is barcode 1334960101
    if (hasDeliveryStopWithScan && hasDeliveryStopCompletedWithoutScan) {
      return {
        processedStops: stops.filter((stop) => {
          if (
            stop.stopType === 1 &&
            (stop.scannedWhen === null || stop.scannedWhen === "")
          ) {
            return false;
          }
          return true;
        }),
        issues: issues,
      };
    } else {
      return {
        processedStops: stops,
        issues: issues,
      };
    }
  } catch (ex) {
    toast.error(
      "There was an issue while processing tracking history for this barcode."
    );
    return [];
  }
};

//helper function for determineOverallStatusForSingleBarcode
//expects the most recent stop that counts as a scan, along with any issues on the order
export const determineOverallStatusFromLatestScan = (stop, issues) => {
  //pass in the latest valid stop that should count towards determining order status
  let statusToReturn = orderStatuses.inTransit; //we can default this to in transit, as we only call this function when we have a stop with a scan on it. (I.e. it is not an open order)
  if (stop.stopType === 5) {
    statusToReturn = orderStatuses.inTransit;
  }
  if (
    (stop.stopType === 0 && stop.contractStopId) ||
    stop.name.includes("Route Load")
  ) {
    statusToReturn = orderStatuses.outForDelivery;
  }
  if (stop.stopType === 0 && !stop.contractStopId) {
    //this means the latest scan is pick up (for return orders only)
    statusToReturn = orderStatuses.inTransit;
  }
  if (stop.stopType === 1) {
    if (stop.scannedWhen && stop.completedTime) {
      statusToReturn = orderStatuses.delivered;
    } else if (stop.scannedWhen) {
      statusToReturn = orderStatuses.italicsDelivered;
    } else if (stop.completedTime) {
      if (issues.includes(deliveryExceptions.hasNoScans.message)) {
        //has completed delivery but no scannedWhen's for any stop
        statusToReturn = orderStatuses.possibleException;
      } else {
        statusToReturn = orderStatuses.deliveredWithPossibleException;
      }
    }
  }
  return { status: statusToReturn, issues: issues };
};
export const determineOverallStatusForSingleBarcode = (stops) => {
  // console.log(stops);
  const filteredStops = stops.filter((stop) => {
    return stopCountsAsScanned(stop);
  });
  const { processedStops, issues: issuesToUse } =
    processAndFilterStops(filteredStops);

  if (processedStops.length === 0) {
    return {
      overallStatusResult: orderStatuses.open,
      issues: [],
      processedTrackingHistory: processedStops,
    };
  }
  // console.log("filtered stops, processed stops:");
  // console.log(filteredStops);
  // console.log(processedStops);
  // console.log(issuesToUse);
  const { status, issues: issuesToReturn } =
    determineOverallStatusFromLatestScan(processedStops[0], issuesToUse);
  return {
    status: status,
    issues: issuesToReturn,
    processedTrackingHistory: processedStops,
  };
};

export const compareScanAddressToActualDestination = (
  scanAddress,
  actualDestination
) => {
  return (
    scanAddress.address?.trim()?.toLowerCase() ===
      actualDestination.address?.trim()?.toLowerCase() &&
    scanAddress.city?.trim()?.toLowerCase() ===
      actualDestination.city?.trim()?.toLowerCase() &&
    scanAddress.state?.trim()?.toLowerCase() ===
      actualDestination.state?.trim()?.toLowerCase() &&
    (/^\d+$/.test(actualDestination.zip.trim()) //if the zip we have in our system is numbers only, compare the zips, if not disregard this check and just return true. Ops sometimes uses letters in the zipcodes for some reason, but for these CXT scans will have the zipcode zeroed out (00000). So let's just disregard for now. Also our system can have a dash followed by a plusfour (ex. 55555-5555) for the zip code. For those cases, CXT's scan will only return the first part of the zip code. So it might be good to add logic for that as well but for now if it has a dash, we will just disregard it.
      ? scanAddress.zip?.trim()?.toLowerCase() ===
        actualDestination.zip?.trim()?.toLowerCase()
      : true)
  );
};
export const scanWasMadeForIncorrectInvoiceAndAddress = (
  scanInfo, //{invoice, location:{address, city, state}}
  destinationInfo //{invoice, location:{address, city, state}}
) => {
  // console.log("scanInfo: ", scanInfo);
  // console.log("destinationInfo: ", destinationInfo);
  // console.log(
  //   scanInfo.invoice?.trim().toLowerCase() !==
  //     destinationInfo.invoice?.trim().toLowerCase() &&
  //     !compareScanAddressToActualDestination(
  //       scanInfo.location,
  //       destinationInfo.location
  //     )
  // );
  return (
    scanInfo.invoice?.trim().toLowerCase() !==
      destinationInfo.invoice?.trim().toLowerCase() &&
    !compareScanAddressToActualDestination(
      scanInfo.location,
      destinationInfo.location
    )
  );
};

// export const isValidEmail = (email, index) => {
//   if (index === 0 && email === "") {
//     return false;
//   } else {
//     // let isValid = true;
//     // const emailHasDot = email.includes(".");
//     // const emailHasAt = email.includes("@");
//     // const dotAfterAt =
//     const emailLastDot = email.lastIndexOf(".");
//     const emailLastAt = email.lastIndexOf("@");
//just trying to recreate the logic of the regex above to see if it is more optimized, can't tell
//     //if a dot comes after the @ AND there is an @ AND the dot isn't the last character, return true
//     return emailLastDot > emailLastAt && emailLastAt !== -1 && emailLastDot != email.length-1;
//   }
// };

export const assembleCityStateZipWithNotFound = (city, state, zip) => {
  return `${city ? city : "N/A"}, ${state ? state : "N/A"} ${
    zip ? zip : "- N/A"
  }`;
};

export const determineHasAccessToCDKFeatures = (currentStatus) => {
  return (
    currentStatus === cdkSubscriptionStatuses.active ||
    currentStatus === cdkSubscriptionStatuses.cancellationPending
  );
};

//keep this function updated with the logic to determine the error displays for the confirm finalize rest modal
export const isValidCDKOrderSubmission = (cdkOrder) => {
  let isValid = true;
  let invalidReasons = [];
  if (cdkOrder.dataToSubmit.timeCode === "") {
    isValid = false;
    invalidReasons.push("Please select a time code.");
  }
  if (
    cdkOrder.dataToSubmit.shipments.filter(
      (shipment) => shipment.declaredValue < 0
    ).length > 0
  ) {
    isValid = false;
    invalidReasons.push("Declared value cannot be negative.");
  }
  if (
    cdkOrder.dataToSubmit.shipments.filter(
      (shipment) =>
        shipment.CODType !== codOptions.None.value &&
        shipment.declaredValue <= 0
    ).length > 0
  ) {
    isValid = false;
    invalidReasons.push("COD shipments must have a declared value.");
  }
  return {
    isValid: isValid,
    reasons: invalidReasons,
  };
};

export const mergeWithGenericCustomizer = (a, b) => {
  // console.log("a", a);
  // console.log("a", typeof a);
  // console.log("b", b);
  // console.log("b", typeof b);
  if (a === undefined) {
    return b;
  }
  if (b === undefined) {
    return a;
  }
  if (typeof a === "object" && typeof b === "object") {
    if (Array.isArray(a) && Array.isArray(b)) {
      return [...a, ...b]; //combine array
    } else {
      return; //return undefined to allow mergeWith to continue combining regular objects recursively.
    }
  }
  // if (typeof a === "number" && typeof b === "number") {
  //   return [a, b];
  // }
  else return [a, b]; //anything else just combine into an array
  // return;
};

const accountLookupTimeCodesSortOrder = {
  NT: 0,
  NN: 1,
  ND: 2,
  SD: 3,
};
export const sortAccountLookupTimeCodes = (timeCodes) => {
  return timeCodes.sort((a, b) => {
    return (
      accountLookupTimeCodesSortOrder[a] - accountLookupTimeCodesSortOrder[b]
    );
  });
};

// display numbers with ordinal suffix
// https://stackoverflow.com/a/13627586/12156650
export function appendOrdinalSuffix(i) {
  let j = i % 10,
    k = i % 100;
  if (j === 1 && k !== 11) {
    return i + "st";
  }
  if (j === 2 && k !== 12) {
    return i + "nd";
  }
  if (j === 3 && k !== 13) {
    return i + "rd";
  }
  return i + "th";
}

//Address Correction==============================================
const addressMap = {
  n: "north",
  s: "south",
  w: "west",
  e: "east",
  hwy: "highway",
  dr: "street",
  drive: "street",
  rd: "street",
  road: "road",
  street: "street",
  st: "street", //not sure bout this one... Because what if it's like st bernard. But if we do the replace on both the strings we are comparing it should still end up fine?
  "i-h": "ih",
};

const correctAndCompareAddress = (address1, address2) => {};

export const generateLocationString = (stop, includeName = true) => {
  return `${
    includeName
      ? stop.name
        ? stop.name.trim() + ", "
        : stop.customerName
        ? stop.customerName.trim() + ", "
        : ""
      : "" //name for client's location, otherwise customerName
  }${stop.address?.trim()}${
    stop.suite ? " suite " + stop.suite.trim() : ""
  }, ${stop.city?.trim()}, ${stop.state?.trim()}, ${stop.zip?.trim()}`;
};
export const generateLocationKey = (stop) => {
  return generateLocationString(stop).toLowerCase().trim();
};

//End Address Correction==========================================

export const notEmpty = (value) => value !== null && value !== undefined;

export const isDev = () => process.env.NODE_ENV === "development";

export const isProd = () => process.env.NODE_ENV === "production";
